var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    attrs: {
      title: _vm.title,
      rightMethod: _vm.saveProduct,
      hasAlert: "",
      medium: ""
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-container",
              { attrs: { fluid: "" } },
              [
                _c(
                  "v-list",
                  { attrs: { subheader: "" } },
                  [
                    _c(
                      "v-list-tile",
                      [
                        _c(
                          "v-layout",
                          { attrs: { row: "", "no-wrap": "" } },
                          [
                            _vm.isLinkMode && _vm.isLinkExistProduct
                              ? _c(
                                  "v-flex",
                                  [
                                    _c("v-autocomplete", {
                                      staticClass: "required_field",
                                      attrs: {
                                        "prepend-icon": "devices_other",
                                        items: _vm.productsWithoutUPC,
                                        "item-text": "name",
                                        "return-object": "",
                                        filter: _vm.customFilter,
                                        rules: [_vm.fieldIsRequired("Name")],
                                        label: _vm.$t("name"),
                                        clearable: ""
                                      },
                                      on: { input: _vm.selectExistProduct },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "selection",
                                            fn: function(data) {
                                              return [
                                                _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      data.item.id.slice(-5)
                                                    ) +
                                                      " - " +
                                                      _vm._s(
                                                        data.item.condition &&
                                                          data.item.condition.toUpperCase()
                                                      ) +
                                                      " - " +
                                                      _vm._s(data.item.name)
                                                  )
                                                ])
                                              ]
                                            }
                                          },
                                          {
                                            key: "item",
                                            fn: function(data) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: { id: data.item.id }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        data.item.id.slice(-5)
                                                      ) +
                                                        " - " +
                                                        _vm._s(
                                                          data.item.condition &&
                                                            data.item.condition.toUpperCase()
                                                        ) +
                                                        " - " +
                                                        _vm._s(data.item.name)
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        335962645
                                      )
                                    })
                                  ],
                                  1
                                )
                              : _c(
                                  "v-flex",
                                  [
                                    _c("v-text-field", {
                                      staticClass: "required_field",
                                      attrs: {
                                        id: "product_name",
                                        label: _vm.$t("name"),
                                        "prepend-icon": "devices_other",
                                        hint: _vm.editMode
                                          ? _vm.$t(
                                              "note:UpdatedProductNameWillOnlyReflectInNewOffers"
                                            )
                                          : "",
                                        "persistent-hint": "",
                                        rules: [_vm.fieldIsRequired("Name")]
                                      },
                                      model: {
                                        value: _vm.productInEdit.name,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.productInEdit,
                                            "name",
                                            $$v
                                          )
                                        },
                                        expression: "productInEdit.name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                            _vm._v(" "),
                            _vm.isLinkMode
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "ml-3",
                                    style: { width: "166px" }
                                  },
                                  [
                                    _c("v-checkbox", {
                                      attrs: {
                                        label: _vm.$t("useExistProduct")
                                      },
                                      model: {
                                        value: _vm.isLinkExistProduct,
                                        callback: function($$v) {
                                          _vm.isLinkExistProduct = $$v
                                        },
                                        expression: "isLinkExistProduct"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { warp: "", "justify-space-between": "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { sm5: "" } },
                      [
                        _c(
                          "v-list",
                          { attrs: { subheader: "" } },
                          [
                            _c(
                              "v-list-tile",
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    id: "product_price",
                                    label: _vm.$t("price"),
                                    "prepend-icon": "attach_money",
                                    rules: [
                                      _vm.fieldIsNumber(),
                                      _vm.fieldIsNoLessThanZero()
                                    ]
                                  },
                                  model: {
                                    value: _vm.productInEdit.price,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.productInEdit,
                                        "price",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression: "productInEdit.price"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { sm5: "" } },
                      [
                        _c(
                          "v-list",
                          { attrs: { subheader: "" } },
                          [
                            _c(
                              "v-list-tile",
                              [
                                _c("v-select", {
                                  staticClass: "required_field",
                                  attrs: {
                                    id: "product_condition",
                                    items: _vm.conditions,
                                    label: _vm.$t("condition"),
                                    "prepend-icon": "thumbs_up_down",
                                    rules: [_vm.fieldIsRequired("condition")],
                                    clearable: ""
                                  },
                                  model: {
                                    value: _vm.productInEdit.condition,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.productInEdit,
                                        "condition",
                                        $$v
                                      )
                                    },
                                    expression: "productInEdit.condition"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  [
                    _c(
                      "v-flex",
                      { staticClass: "mx-3" },
                      [
                        _c("v-combobox", {
                          attrs: {
                            id: "product_asin",
                            label: "ASIN",
                            chips: "",
                            multiple: "",
                            "deletable-chips": "",
                            "prepend-icon": "filter_list",
                            clearable: ""
                          },
                          model: {
                            value: _vm.productInEdit.asin,
                            callback: function($$v) {
                              _vm.$set(_vm.productInEdit, "asin", $$v)
                            },
                            expression: "productInEdit.asin"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { staticClass: "mb-1" },
                  [
                    _c(
                      "v-flex",
                      { staticClass: "mx-3" },
                      [
                        _c("v-combobox", {
                          attrs: {
                            label: "SKU",
                            chips: "",
                            multiple: "",
                            "deletable-chips": "",
                            "prepend-icon": "filter_list",
                            clearable: "",
                            rules: [_vm.checkSkuDup]
                          },
                          model: {
                            value: _vm.productInEdit.sku,
                            callback: function($$v) {
                              _vm.$set(_vm.productInEdit, "sku", $$v)
                            },
                            expression: "productInEdit.sku"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  {
                    staticClass: "mx-3",
                    attrs: {
                      warp: "",
                      "justify-space-between": "",
                      "align-baseline": ""
                    }
                  },
                  [
                    _c(
                      "v-flex",
                      { attrs: { sm10: "" } },
                      [
                        _c("v-text-field", {
                          ref: "UPC",
                          attrs: {
                            id: "upc",
                            label: "UPC",
                            "prepend-icon": "bookmarks",
                            readonly:
                              !_vm.productInEdit.isUpcChangeable ||
                              _vm.upcReadOnly ||
                              !!(
                                _vm.productInEdit.approvedSkus &&
                                _vm.productInEdit.approvedSkus.length
                              ),
                            title: _vm.$t("productEditUpc"),
                            hint: !_vm.productInEdit.isUpcChangeable
                              ? _vm.$t("productEditWarning")
                              : _vm.$t("case-sensitive", { field: "UPC" }),
                            rules: [_vm.rules.upcValid, _vm.rules.upcDup]
                          },
                          model: {
                            value: _vm.displayUPC,
                            callback: function($$v) {
                              _vm.displayUPC = $$v
                            },
                            expression: "displayUPC"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { sm2: "" } },
                      [
                        _c("LoaderButton", {
                          attrs: {
                            flat: "",
                            promiseAwait: _vm.checkArchive,
                            buttonText: _vm.$t("checkArchive"),
                            disabled: !_vm.upcValue
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.isInboundForecastDropshipping
                  ? _c(
                      "v-layout",
                      {
                        attrs: {
                          "pl-3": "",
                          "pr-5": "",
                          "justify-start": "",
                          "align-baseline": ""
                        }
                      },
                      [
                        _c("v-flex", { attrs: { xs3: "" } }, [
                          _c("label", [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.$t("productDimensions")))
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs3: "" } },
                          [
                            _c("v-text-field", {
                              staticClass: "required_field",
                              attrs: {
                                "hide-details": "",
                                rules: [
                                  _vm.fieldIsRequired("weight"),
                                  _vm.fieldIsOverZero("weight")
                                ],
                                label: _vm.$t("weight"),
                                suffix: _vm.weightSuffix
                              },
                              model: {
                                value: _vm.productInEdit.weight,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.productInEdit,
                                    "weight",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "productInEdit.weight"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs3: "" } },
                          [
                            _c("v-text-field", {
                              staticClass: "required_field",
                              attrs: {
                                "hide-details": "",
                                label: _vm.$t("L"),
                                suffix: _vm.sizeSuffix,
                                rules: [
                                  _vm.fieldIsRequired("length"),
                                  _vm.fieldIsOverZero("length")
                                ]
                              },
                              model: {
                                value: _vm.productInEdit.length,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.productInEdit,
                                    "length",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "productInEdit.length"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs3: "" } },
                          [
                            _c("v-text-field", {
                              staticClass: "required_field",
                              attrs: {
                                "hide-details": "",
                                label: _vm.$t("W"),
                                suffix: _vm.sizeSuffix,
                                rules: [
                                  _vm.fieldIsRequired("width"),
                                  _vm.fieldIsOverZero("width")
                                ]
                              },
                              model: {
                                value: _vm.productInEdit.width,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.productInEdit,
                                    "width",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "productInEdit.width"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs3: "" } },
                          [
                            _c("v-text-field", {
                              staticClass: "required_field",
                              attrs: {
                                "hide-details": "",
                                suffix: _vm.sizeSuffix,
                                label: _vm.$t("H"),
                                rules: [
                                  _vm.fieldIsRequired("height"),
                                  _vm.fieldIsOverZero("height")
                                ]
                              },
                              model: {
                                value: _vm.productInEdit.height,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.productInEdit,
                                    "height",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "productInEdit.height"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isInboundForecastDropshipping
                  ? _c("ShippingRangeEditor", {
                      attrs: {
                        value: _vm.shippingRanges,
                        materialFees: [],
                        readonly: true,
                        unit: _vm.product.unit || _vm.tenantUnit
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isInboundForecastDropshipping &&
                !!_vm.product.warehouseLastUpdateTime &&
                +_vm.product.warehouseLastUpdateTime >
                  +_vm.product.lastModifiedTime
                  ? _c(
                      "v-layout",
                      {
                        attrs: { "pl-3": "", "pr-5": "", "justify-start": "" }
                      },
                      [
                        _c(
                          "v-flex",
                          { attrs: { "ml-1": "" } },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("warehouseVerifiedDimensions")) +
                                " "
                            ),
                            _c("v-icon", { attrs: { color: "success" } }, [
                              _vm._v("check")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-layout",
                  [
                    _c(
                      "v-flex",
                      { staticClass: "ml-3 confirm_upc" },
                      [
                        _vm.upcWarning
                          ? _c("v-checkbox", {
                              staticClass: "productEditCheckBox",
                              attrs: {
                                label: _vm.upcWarning,
                                color: "blue",
                                name: "confirmUpc",
                                rules: [
                                  function(v) {
                                    return v || _vm.$t("confirmUpc")
                                  }
                                ]
                              },
                              model: {
                                value: _vm.isConfirmed,
                                callback: function($$v) {
                                  _vm.isConfirmed = $$v
                                },
                                expression: "isConfirmed"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { id: "product_note" } },
                  [
                    _c(
                      "v-flex",
                      { staticClass: "mx-3" },
                      [
                        _c("v-textarea", {
                          staticClass: "thinBox",
                          attrs: { label: _vm.$t("note"), outline: "" },
                          model: {
                            value: _vm.productInEdit.note,
                            callback: function($$v) {
                              _vm.$set(_vm.productInEdit, "note", $$v)
                            },
                            expression: "productInEdit.note"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a7c6919", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a7c6919","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductEdit.vue
// module id = null
// module chunks = 